export default {
  // 次数包价格后缀
  'pages.voiceClone.packPriceSimple': '（{quota} 次 / ¥{price}）',
  'pages.voiceClone.packPricePrefix': '（{quota} 次 / ',
  'pages.voiceClone.packPriceOriginal': '原价 ¥{price}',
  'pages.voiceClone.packPriceDiscount': '活动优惠 ¥{price}',
  'pages.voiceClone.packPricePaid': '实付 ¥{price}',
  'pages.voiceClone.packPriceClose': '）',

  // 购买须知
  'pages.voiceClone.purchaseNoticeTitle': '购买须知',
  'pages.voiceClone.purchaseNoticeEffectiveDate': '2026年5月30日',
  'pages.voiceClone.purchaseNoticeEffective': '版本生效日期：{date}',
  'pages.voiceClone.purchaseNoticeGreeting':
    '尊敬的用户，感谢您选择「{platformName}」声音复刻服务。请在完成支付前仔细阅读以下条款：',
  'pages.voiceClone.purchaseNoticeSupplement':
    '本须知作为《用户协议》的补充，与《用户协议》及声音复刻服务页面展示内容共同构成完整约定；未尽事宜以《用户协议》及服务页面为准。',
  'pages.voiceClone.purchaseNoticeSec1Title': '1. 服务权益',
  'pages.voiceClone.purchaseNoticeSec1Intro':
    '您购买的声音复刻服务，可用于克隆本人声音，或上传您已依法取得授权的他人声音样本。核心权益包括：',
  'pages.voiceClone.purchaseNoticeSec1Item1':
    '（1）服务期为 1 年，自您支付成功当日起算；您须在上述期限内使用本订单所含的克隆次数。若单个音色在过去 1 年内未被用于任何语音合成请求，音色克隆提供商将自动删除该音色导致到期后不能正常合成',
  'pages.voiceClone.purchaseNoticeSec1Item2':
    '（2）同一「{platformName}」账号下，已复刻音色在同一时间可绑定使用的设备数量不超过 5 台。',
  'pages.voiceClone.purchaseNoticeSec1Item3':
    '（3）同一「{platformName}」下单成功后相应订单7日内未使用过克隆次数的可以申请退款，超过或者已使用过不支持退款。',
  'pages.voiceClone.purchaseNoticeSec2Title': '2. 合法使用',
  'pages.voiceClone.purchaseNoticeSec2Body':
    '您理解并同意：本服务与您的账号及信息安全相关，您购买的服务仅限本人账号按平台规则使用；未经书面许可，不得以转让、出租、出售或其他方式向第三方提供或授权使用。',
  'pages.voiceClone.purchaseNoticeSec3Title': '3. 联系我们',
  'pages.voiceClone.purchaseNoticeSec3Body':
    '若您对以上条款或服务有疑问，或存在特殊使用场景，请通过《用户协议》或应用内公示的客服渠道与我们联系。',
  'pages.voiceClone.purchaseNoticeAgree': '我已认真阅读并理解上述购买须知',
  'pages.voiceClone.agreeAndPay': '同意并继续支付',

  // 次数包订单
  'pages.voiceClone.orderLoadFailed': '加载订单失败',
  'pages.voiceClone.orderDetailLoadFailed': '加载详情失败',
  'pages.voiceClone.refundSubmitted': '已提交退款申请',
  'pages.voiceClone.refundFailed': '退款失败',
  'pages.voiceClone.orderCanceled': '已取消待支付订单',
  'pages.voiceClone.orderCancelFailed': '取消失败',
  'pages.voiceClone.colOrderNo': '订单号',
  'pages.voiceClone.colAmountYuan': '金额(元)',
  'pages.voiceClone.colQuotaPack': '次数包',
  'pages.voiceClone.quotaRemainingOfTotal': '余 {remaining}/{total}',
  'pages.voiceClone.colStatus': '状态',
  'pages.voiceClone.detailAction': '详情',
  'pages.voiceClone.refundConfirmTitle': '确认申请原路退款？',
  'pages.voiceClone.refundConfirmContentUnused':
    '该次数包尚未用于克隆，退款成功后对应次数包配额将失效，款项按微信支付原路退回。',
  'pages.voiceClone.refundConfirmContentFailed':
    '该订单为失败单且次数未被消耗，确认发起微信原路退款？款项将按原支付路径退回。',
  'pages.voiceClone.refundConfirmOk': '确认退款',
  'pages.voiceClone.refundAction': '申请原路退款',
  'pages.voiceClone.refundNotAllowedTipUsed': '该次数包已有克隆消耗，不支持微信原路退款',
  'pages.voiceClone.refundNotAllowed': '不可退款',
  'pages.voiceClone.refundNotAllowedTipExpired': '已超过支付成功后 7 日内未使用原路退款期限，或款项已退',
  'pages.voiceClone.filterStatusAll': '全部',
  'pages.voiceClone.statusPending': '待支付',
  'pages.voiceClone.statusPaid': '已支付',
  'pages.voiceClone.statusCompleted': '已完成',
  'pages.voiceClone.statusFailed': '失败',
  'pages.voiceClone.statusCanceled': '已取消',
  'pages.voiceClone.filterOrderNoPlaceholder': '订单号（模糊）',
  'pages.voiceClone.queryAction': '查询',
  'pages.voiceClone.orderDetailTitle': '订单详情',
  'pages.voiceClone.detailWechatTradeNo': '微信交易号',
  'pages.voiceClone.detailFailedReason': '失败原因',
  'pages.voiceClone.detailRefundStatus': '退款状态',
  'pages.voiceClone.quotaSummary': '共 {total}，已用 {used}，剩余 {remaining}',
  'pages.voiceClone.unusedRefundDeadline': '未使用原路退款截止：{date}',

  // 主页面通用
  'pages.voiceClone.defaultRefText':
    '清晨的阳光洒进窗台，新的一天开始了。无论昨天经历了什么，今天都是崭新的机会。保持微笑，用心感受生活的每一个瞬间，你会发现美好其实就在身边。',
  'pages.voiceClone.platformNameFallback': '本平台',
  'pages.voiceClone.renameAction': '修改名称',
  'pages.voiceClone.usageAlertTitle': '音色克隆使用提示',
  'pages.voiceClone.usageAlertDesc1':
    '上传仅支持 <b>WAV</b>，单文件不超过 <b>{mb}MB</b>；用于复刻的选区时长须在 <b>{min}～{max} 秒</b>。单人朗读、发音清晰，尽量避免明显沙哑嗓、气音与房间回声。',
  'pages.voiceClone.usageAlertDesc2':
    '克隆训练<b>成功并完成入库</b>后，方可在智能体维护页的<b>角色音色</b>中选择使用。',
  'pages.voiceClone.buyPackTitle': '购买音色克隆次数',
  'pages.voiceClone.orderNoLabel': '订单号：{orderNo}',
  'pages.voiceClone.payScanTip': '请使用微信扫码支付；支付成功后次数自动到账。',
  'pages.voiceClone.payQuotaPerPurchase': ' 单次购买含 {quota} 次克隆。',
  'pages.voiceClone.remainingQuota': '剩余克隆次数：',
  'pages.voiceClone.buyPackHint': '可购买次数包扩展配额',
  'pages.voiceClone.buyPackButton': '购买克隆次数包',
  'pages.voiceClone.renameModalTitle': '修改克隆音色名称',
  'pages.voiceClone.renameRequired': '请输入名称',
  'pages.voiceClone.renameMax': '最多 30 个字符',
  'pages.voiceClone.renamePlaceholder': '在角色音色列表中显示的名称',

  // 语言下拉展示
  'pages.voiceClone.lang.mandarin': '普通话',
  'pages.voiceClone.lang.cantonese': '粤语',
  'pages.voiceClone.lang.english': '英语',
  'pages.voiceClone.lang.japanese': '日语',
  'pages.voiceClone.lang.korean': '韩语',
  'pages.voiceClone.lang.french': '法语',
  'pages.voiceClone.lang.german': '德语',
  'pages.voiceClone.lang.spanish': '西班牙语',
  'pages.voiceClone.lang.portuguese': '葡萄牙语',
  'pages.voiceClone.lang.russian': '俄语',
  'pages.voiceClone.lang.italian': '意大利语',
  'pages.voiceClone.lang.arabic': '阿拉伯语',
  'pages.voiceClone.lang.turkish': '土耳其语',
  'pages.voiceClone.lang.polish': '波兰语',
  'pages.voiceClone.lang.catalan': '加泰罗尼亚语',

  // 表单校验与录音/上传交互
  'pages.voiceClone.fieldRefTextHintMinimax':
    '请按此文案朗读录制；平台存档用，默认不向 MiniMax 发送 ASR 逐字校验',
  'pages.voiceClone.aliasMaxRule': '最多 30 个字符（与服务器校验一致）',
  'pages.voiceClone.languageRequired': '请选择语言',
  'pages.voiceClone.refTextRequired': '请填写参考文本',
  'pages.voiceClone.refTextTooLong': '参考文本过长',
  'pages.voiceClone.providerRequired': '请选择 TTS 提供商',
  'pages.voiceClone.fieldProviderHint':
    '请选择已接入声音克隆的 TTS；克隆音色需与智能体使用同一提供商类型才能合成',
  'pages.voiceClone.noCloneProvider': '暂无已实现克隆的 TTS，请先在系统配置中添加并启用',
  'pages.voiceClone.fieldMode': '模式',
  'pages.voiceClone.modeRecord': '录音',
  'pages.voiceClone.modeUpload': '上传文件',
  'pages.voiceClone.recordLabel': '录音',
  'pages.voiceClone.uploadLabel': '上传',
  'pages.voiceClone.recordStop': '点击停止录音',
  'pages.voiceClone.recordStart': '点击开始录音',
  'pages.voiceClone.recordElapsed': '已录 {sec} 秒（建议 {minSec}～{maxSec} 秒）',
  'pages.voiceClone.recordDebugHint':
    "排查：确认麦克风未静音、Chrome 已允许本站麦克风、页面为 HTTPS；避免选成「立体声混音」等环回输入。技术联调请在控制台执行 localStorage.setItem('voiceCloneMicDebug','1') 后刷新再录，查看以 [voiceclone-mic] 开头的日志。",
  'pages.voiceClone.confirmAudioTooltip':
    '请先录音或上传 WAV，在下方确认面板中试听选区并点击「确认音频」',
  'pages.voiceClone.clipConfirmed': '已确认用于上传的片段，可继续试听或重新裁剪/更换音源',
  'pages.voiceClone.confirmedClipTitle': '已确认片段',
  'pages.voiceClone.confirmedClipDesc':
    '以下为将随「上传样本」提交的裁剪后 WAV，可试听核对；仍可修改参考文本、名称等表单内容。',
  'pages.voiceClone.reclip': '重新裁剪',
  'pages.voiceClone.rerecord': '重新录音 / 重新选文件',
  'pages.voiceClone.renameSuccess': '名称已更新',
  'pages.voiceClone.renameFailed': '更新失败',

  // 提示与错误
  'pages.voiceClone.errRecordingEmpty': '录音数据为空，请多录几秒再停止',
  'pages.voiceClone.errNoValidWaveform': '未检测到有效声波，请对着麦克风说话或检查浏览器是否选对录音设备',
  'pages.voiceClone.errCheckQuotaFailed': '无法校验克隆次数',
  'pages.voiceClone.warnQuotaInsufficient': '克隆次数不足，请先购买次数包后再试',
  'pages.voiceClone.createOrderFailed': '创建订单失败',
  'pages.voiceClone.errNoPayQr': '未获取到支付二维码，请确认服务端已配置微信 Native 支付',
  'pages.voiceClone.paySuccess': '支付成功，克隆次数已到账',
  'pages.voiceClone.placeOrderFailed': '下单失败',
  'pages.voiceClone.errMicAccess': '无法访问麦克风，请检查浏览器权限与设备',
  'pages.voiceClone.warnStereoMix':
    '当前为「立体声混音」等环回设备，不是麦克风：无系统播放时常常采不到有效声音。人声克隆请在系统/浏览器里改选真实麦克风。',
  'pages.voiceClone.warnMicMuted': '检测到麦克风声轨为静音，请在系统混音器或浏览器标签页中取消静音后再录。',
  'pages.voiceClone.errNoAudioRetry': '未采集到音频数据，请重试并稍长再停止录音',
  'pages.voiceClone.recordMinDuration': '录音时长须不少于 {minSec} 秒，请重新录制',
  'pages.voiceClone.errRecordProcessFailed': '录音处理失败，请改用「上传 wav」或重试',
  'pages.voiceClone.errNoAudioStereoMix':
    '未采集到音频：当前为「立体声混音」等环回输入，不是麦克风；无桌面/扬声器播放时常无任何样本。请在 Windows「设置 → 系统 → 声音 → 输入」或 Chrome 地址栏麦克风权限中改选真实麦克风后再录。',
  'pages.voiceClone.errNoAudioSamples': '未采集到音频数据，请多录几秒再停止；若仍失败请换用「上传 wav」。',
  'pages.voiceClone.errConfirmAudioFirst': '请先完成音频确认：在确认面板中试听选区并点击「确认音频」',
  'pages.voiceClone.uploadVoiceSampleFailed': '上传声音样本失败',
  'pages.voiceClone.errOnlyWav': '仅支持 WAV 格式',
  'pages.voiceClone.errFileTooLarge': '文件大小不能超过 {mb}MB',
  'pages.voiceClone.errInvalidWavHeader': '请选择有效的 WAV 文件（RIFF/WAVE 头）',
  'pages.voiceClone.errAudioMinDuration': '音频时长须不少于 {minSec} 秒',
  'pages.voiceClone.errParseWavFailed': '无法解析该 WAV 文件',
  'pages.voiceClone.errMissingSampleId': '缺少样本 ID，请返回第 1 步重新上传',
  'pages.voiceClone.warnNoMasterAudio': '无整段原始音频，请重新录音或选择文件',

  // 音频确认面板（VoiceCloneAudioReview）
  'pages.voiceClone.review.durationTooShort': '有效音频时长须不少于 {minSec} 秒，请重新录制或更换文件',
  'pages.voiceClone.review.parseWavFailed': '无法解析该 WAV，请检查文件是否损坏',
  'pages.voiceClone.review.audioNotReady': '音频尚未就绪，请稍候再试',
  'pages.voiceClone.review.adjustSelection': '请调整选区，使时长在 {minSec}～{maxSec} 秒之间',
  'pages.voiceClone.review.selectionInvalid': '选区无效，请重新拖动滑块',
  'pages.voiceClone.review.decodePlayFailed': '无法解码或播放该片段，请尝试缩短选区或更换浏览器',
  'pages.voiceClone.review.playFailed': '无法播放，请检查浏览器是否允许音频播放',
  'pages.voiceClone.review.selectionSpanRule': '选区时长须为 {minSec}～{maxSec} 秒',
  'pages.voiceClone.review.trimmedTooLarge': '裁剪后 WAV 超过 {maxMb}MB，请缩短选区',
  'pages.voiceClone.review.parsingAudio': '解析音频…',
  'pages.voiceClone.review.title': '音频确认',
  'pages.voiceClone.review.tip':
    '试听整段中的选中部分；拖动两端竖块调整起止时间。选区时长须在 {minSec}～{maxSec} 秒。不满意可点「重置」重新录制或上传。',
  'pages.voiceClone.review.selectionSpan': '选区时长：{span} s',
  'pages.voiceClone.review.selectionSpanNeed': '（需 {minSec}～{maxSec} s）',
  'pages.voiceClone.review.playSelection': '播放选区',
  'pages.voiceClone.review.confirmAudio': '确认音频',
  'pages.voiceClone.review.reset': '重置',

  // 录音建议（VoiceCloneRecordingTips）
  'pages.voiceClone.tips.collapseLabel': '录音建议',
  'pages.voiceClone.tips.intro': '高质量的输入音频是获得优质复刻效果的基础。',
  'pages.voiceClone.tips.deviceTitle': '录音设备',
  'pages.voiceClone.tips.deviceText':
    '可使用手机、数字录音笔、专业录音机等。建议使用支持高采样率（≥ 24 kHz）录音的设备，以满足音频要求。',
  'pages.voiceClone.tips.envTitle': '录音环境',
  'pages.voiceClone.tips.venueLabel': '场地',
  'pages.voiceClone.tips.venue1': '建议在 10 平方米以内的小型封闭空间录音。',
  'pages.voiceClone.tips.venue2': '优先选择配有吸音材料（如吸音棉、地毯、窗帘）的房间。',
  'pages.voiceClone.tips.venue3': '避免空旷大厅、会议室、教室等高混响场所。',
  'pages.voiceClone.tips.noiseLabel': '噪音控制',
  'pages.voiceClone.tips.noiseOutdoorLabel': '室外噪音：',
  'pages.voiceClone.tips.noiseOutdoorText': '关闭门窗，避免交通、施工等干扰。',
  'pages.voiceClone.tips.noiseIndoorLabel': '室内噪音：',
  'pages.voiceClone.tips.noiseIndoorText':
    '关闭空调、风扇、日光灯镇流器等设备；可通过手机录制环境音并放大播放，识别潜在噪音源。',
  'pages.voiceClone.tips.reverbLabel': '混响控制',
  'pages.voiceClone.tips.reverb1': '混响会导致声音模糊、清晰度下降。',
  'pages.voiceClone.tips.reverb2': '减少光滑表面反射：拉上窗帘、打开衣柜门、铺放衣物或床单覆盖桌面/柜面。',
  'pages.voiceClone.tips.reverb3': '利用不规则物体（如书架、软包家具）实现声波漫反射。',
  'pages.voiceClone.tips.scriptTitle': '录音文案',
  'pages.voiceClone.tips.script1': '内容无特殊限制，建议与目标应用场景一致。',
  'pages.voiceClone.tips.script2': '避免短句（如「你好」、「是的」），应使用完整句子。',
  'pages.voiceClone.tips.script3': '保持语义连贯，朗读时避免频繁停顿（建议至少连续 3 秒无中断）。',
  'pages.voiceClone.tips.script4': '录音全程保持一致的语速，避免开头或结尾语速过快导致合成时出现卡顿。',
  'pages.voiceClone.tips.script5': '可加入适当情绪表达（如温暖、亲切、严肃），避免机械朗读。',
  'pages.voiceClone.tips.script6': '不包含敏感词汇（如政治、色情、暴力相关内容），否则会导致复刻失败。',
  'pages.voiceClone.tips.opTitle': '操作建议',
  'pages.voiceClone.tips.opIntro': '以普通卧室为例，完成降噪和混响控制后：',
  'pages.voiceClone.tips.op1': '提前熟悉文案，设定角色语气，自然演绎。',
  'pages.voiceClone.tips.op2': '与录音设备保持约 10 厘米距离，避免喷麦或信号过弱。',
};
